exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".YTkrxfGEmNMMIDJUNY4AH{background-color:#322d63;color:#fff;cursor:pointer;font-family:fira_sansregular,Arial;font-weight:700;transition:all .2s;max-width:100%;width:325px;border:1px solid transparent;border-radius:6px;height:47px;font-size:20px}.YTkrxfGEmNMMIDJUNY4AH:hover{background-color:#e3a527}", ""]);

// exports
exports.locals = {
	"button": "YTkrxfGEmNMMIDJUNY4AH"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/sass-loader!./src/components/Button.scss
 ** module id = 290
 ** module chunks = 0
 **/